import { Dropdown } from 'react-bootstrap'
import { EditorTypeName } from '.'
import { PromiseVoid } from '../../../types'
import { WindowMode } from '../../mathdown/editor/types'

type Props = {
  windowMode: WindowMode
  onChangeWindowMode: (mode: WindowMode) => PromiseVoid
  editorType: EditorTypeName
  onChangeEditorType: (type: EditorTypeName) => PromiseVoid
}

export const EditorTypeChangeDropdownItems = ({
  windowMode,
  onChangeWindowMode: handleChangeWindowMode,
  editorType,
  onChangeEditorType: handleChangeEditorType,
}: Props) => {
  return (
    <>
      <Dropdown.Header>モード変更</Dropdown.Header>
      <Dropdown.Item
        onClick={() => {
          void handleChangeWindowMode('input')
          void handleChangeEditorType('mathdown')
        }}
        active={editorType === 'mathdown' && windowMode === 'input'}
      >
        本文の入力
      </Dropdown.Item>
      <Dropdown.Item
        onClick={() => {
          void handleChangeWindowMode('output')
          void handleChangeEditorType('mathdown')
        }}
        active={editorType === 'mathdown' && windowMode === 'output'}
      >
        プレビュー
      </Dropdown.Item>
      <Dropdown.Item
        onClick={() => {
          void handleChangeEditorType('references')
        }}
        active={editorType === 'references'}
      >
        参考文献の編集
      </Dropdown.Item>
      <Dropdown.Item
        onClick={() => {
          void handleChangeEditorType('macros')
        }}
        active={editorType === 'macros'}
      >
        マクロの編集
      </Dropdown.Item>
    </>
  )
}
